// react import
import React, { useRef } from "react";
import styled from "styled-components";

import { CrossIcon } from "../icon/Icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { commonAction } from "../slices/GameSlice";

const CommonAlertModal = ({ title, handler, children }) => {
  const dispatch = useDispatch();
  const navigator = useNavigate();
  const roomRef = useRef();

  const EnterHandler = () => {
    navigator(`project/${roomRef.current.value}`);
    dispatch(commonAction({ target: "alertDisplay", value: false }));
  };

  const CloseHandler = () => {
    dispatch(commonAction({ target: "alertDisplay", value: false }));
  };

  return (
    <Wrap>
      <Header>
        {title}
        <span style={{ cursor: "pointer" }} onClick={CloseHandler}>
          <CrossIcon />
        </span>
      </Header>
      <InputContainer>
        <span>방 번호</span>
        <RoomInput ref={roomRef} />
      </InputContainer>
      <Footer>
        <ModalButton style={styles[1]} onClick={EnterHandler}>
          입장
        </ModalButton>
        <ModalButton style={styles[2]} onClick={CloseHandler}>
          취소
        </ModalButton>
      </Footer>
    </Wrap>
  );
};

export default CommonAlertModal;

const Wrap = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  translate: -50% -50%;
  width: 342px;
  height: 216px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 5;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const RoomInput = styled.input`
  width: 100%;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #8a8a8a;
  padding: 6px 12px;
  box-sizing: border-box;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 700;

  span {
    translate: 12px -12px;
  }
`;

const Footer = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: end;
`;

const ModalButton = styled.div`
  width: 82px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

const styles = {
  1: { backgroundColor: "#107C41", color: "#FFF" },
  2: { backgroundColor: "#fff", color: "#242424", border: "1px solid #8a8a8a" },
};
